import { Action, createReducer, on } from "@ngrx/store";
import { InvViewColumn1ViewModelActions } from "../actions";
import {
  initialState,
  Column1ViewModelState,
} from "../states/column_1_view_model.states";
export const InvViewColumn1ViewModelReducer = createReducer(
  initialState,
  on(InvViewColumn1ViewModelActions.setGenericDocInvListing_State, (state, action) => ({
    ...state, genericDocInvListingState: action.genericDocInvListingState
  })),
);
export function reducer(
  state: Column1ViewModelState | undefined,
  action: Action
) {
  return InvViewColumn1ViewModelReducer(state, action);
}